import { Capacitor } from '@capacitor/core';
import * as Sentry from '@sentry/capacitor';
import { differenceInDays, format, isToday, isTomorrow } from 'date-fns';
import numeral from 'numeral';
import 'numeral/locales/pt-br';
import { Role } from '../types/enums';
import { DraftPosition } from '../types/types';
import { isApk } from './version';

export const sentryCapture = (
	error: string,
	customTag: string,
	levelError: Sentry.SeverityLevel
) => {
	Sentry.setTag('my-tag', customTag);
	Sentry.captureException(new Error(error));
};

export const headerHeight = () => {
	if (Capacitor.isNativePlatform()) {
		const platform = Capacitor.getPlatform();
		if (platform === 'android') {
			return 'pt-2';
		}
	} else {
		return 'pt-2';
	}
	return '';
};

export const darkModeByRoute = (routeName: string) => {
	const routesBackgroundDark = ['/help', '/profile'];

	if (routesBackgroundDark.includes(routeName)) {
		return true;
	}
	return false;
};

export const validateUserName = (username: string) => {
	const maskPattern = /^@[a-zA-Z0-9]*$/;
	const maskedUsername = username.startsWith('@')
		? username.slice(1)
		: username;
	if (!maskPattern.test(username)) {
		return false;
	}
	if (maskedUsername.length <= 3 || maskedUsername.length > 15) {
		return false;
	}

	if (/[^a-zA-Z0-9]/.test(maskedUsername)) {
		return false;
	}
	return true;
};

export const getErrorMessage = (error: any) => {
	if (error.response) {
		console.error('Data:', error.response.data);
		return (
			error.response.data.message ||
			'Houve um problema ao tentar conectar ao servidor. Tente novamente em alguns minutos.'
		);
	} else if (error.request) {
		console.error('Request:', error.request);
		return 'Houve um problema ao tentar conectar ao servidor. Tente novamente em alguns minutos.';
	} else {
		console.error('Error Message:', error.message);
		return error.message;
	}
};

export const formatBalance = (value: number) => {
	return value * -1;
};

export const countRealTime = (finishAt: any) => {
	const start = new Date();
	const finish = new Date(finishAt.replace('Z', ''));
	const diffMs = finish.getTime() - start.getTime();

	if (diffMs <= 0) {
		return {
			days: 0,
			hours: 0,
			minutes: 0,
			seconds: 0,
			isFinished: true,
		};
	}
	const diffSecs = Math.floor(diffMs / 1000);
	const days = Math.floor(diffSecs / (3600 * 24));
	const hours = Math.floor((diffSecs % (3600 * 24)) / 3600);
	const minutes = Math.floor((diffSecs % 3600) / 60);
	const seconds = diffSecs % 60;

	return { days, hours, minutes, seconds, isFinished: false };
};

export const abbreviateAward = (award: number) => {
	const suffixes = ['', 'k', 'mi', 'bi'];
	let index = 0;

	while (award >= 1000 && index < suffixes.length - 1) {
		award /= 1000;
		index++;
	}

	return award.toFixed() + suffixes[index];
};

export const areMandatoryQuestionsAnswered = (options: any, selected: any) => {
	const mandatoryOptionIds = options.map((option: any) => option.id);
	const selectedOptionIds = selected.map(
		(question: any) => question.optionId
	);
	return mandatoryOptionIds.every((id: any) =>
		selectedOptionIds.includes(id)
	);
};

export const transformInitial = (name: string) => {
	let clearName = name.replace(/^@/, '');

	return clearName.slice(0, 2).toUpperCase();
};

export const transformInitialModality = (name: string) => {
	let clearName = name.replace(/^@/, '');

	if (clearName === 'Futebol Americano') {
		return 'FTA';
	}

	return clearName.slice(0, 3).toUpperCase();
};

export const generatePrivateKey = () => {
	const characters =
		'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	const size = Math.floor(Math.random() * 6) + 25;
	let result = '';

	for (let i = 0; i < size; i++) {
		const index = Math.floor(Math.random() * characters.length);
		result += characters[index];
	}

	return result;
};
export const CurrencyFormatter = (entryAmt: any) => {
	numeral.locale('pt-br');

	return numeral(entryAmt).format('0,0.00');
};
export const CurrencyFormatterNonDecimal = (entryAmt: any) => {
	numeral.locale('pt-br');
	return numeral(entryAmt).format('0,0');
};

export const generateUrl = (title: string, message: string) => {
	switch (title) {
		case 'Linkedin':
			return `https://www.linkedin.com/feed/?shareActive=true&text=${encodeURIComponent(
				message
			)}`;
		case 'Instagram':
			return 'https://www.instagram.com';
		case 'Whatsapp':
			return `https://api.whatsapp.com/send/?text=${encodeURIComponent(
				message
			)}&type=custom_url&app_absent=0`;
		case 'Facebook':
			return `https://www.facebook.com/share_channel/?type=reshare&link=www.${choosePlatformDomainName()}&app_id=966242223397117&source_surface=external_reshare`;
		case 'X':
			return `https://x.com/intent/post?text=${encodeURIComponent(
				message
			)}`;
		case 'Threads':
			return `https://www.threads.net`;
		case 'TikTok':
			return `https://www.tiktok.com`;
		default:
			return '';
	}
};

export const validateKeyPix = (key: string) => {
	key = key.replace(/[^\w]/g, '');

	if (key.length !== 32) {
		return false;
	}

	const defaultKeyPix =
		/^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
	if (defaultKeyPix.test(key)) {
		return false;
	}

	return true;
};

export const showWalletAndBalance = () => {
	if (Capacitor.getPlatform() === 'android' && isApk) {
		return true;
	} else if (Capacitor.getPlatform() === 'android') {
		return false;
	} else {
		return true;
	}
};

export const toggleScroll = (open: boolean) => {
	const scrollTop = window.scrollY || document.documentElement.scrollTop;

	if (open) {
		document.body.classList.add('overflow-hidden');
		document.body.style.top = `-${scrollTop}px`;
		document.body.style.overflow = 'unset';
		document.body.style.position = 'fixed';
		document.body.style.width = '100%';
		document.getElementById('launcher')?.classList.add('hidden');
		const ionContent = document.querySelector('ion-content');
		if (ionContent && ionContent.shadowRoot) {
			const shadowRoot = ionContent.shadowRoot;
			const innerScrollDivs =
				shadowRoot.querySelectorAll('.inner-scroll');
			if (innerScrollDivs.length > 0) {
				const innerScrollDiv = innerScrollDivs[0] as HTMLElement;
				innerScrollDiv.classList.remove('scroll-y');
			}
		}
	} else {
		document.body.classList.remove('overflow-hidden');
		document.body.style.top = '';
		document.body.style.overflow = 'hidden';
		document.body.style.position = '';
		document.body.style.width = '';
		document.getElementById('launcher')?.classList.remove('hidden');
		const ionContent = document.querySelector('ion-content');
		if (ionContent && ionContent.shadowRoot) {
			const shadowRoot = ionContent.shadowRoot;
			const innerScrollDivs =
				shadowRoot.querySelectorAll('.inner-scroll');
			if (innerScrollDivs.length > 0) {
				const innerScrollDiv = innerScrollDivs[0] as HTMLElement;
				innerScrollDiv.classList.add('scroll-y');
			}
		}
	}
};

export const isMobileWeb = () => {
	const userAgent: string = navigator.userAgent || navigator.vendor || '';
	return /android|iphone|ipad|ipod|windows phone/i.test(userAgent);
};

export const getMobilePlatform = () => {
	const userAgent = navigator.userAgent || navigator.vendor;

	if (/android/i.test(userAgent)) {
		console.log('Dispositivo: Android (Navegador)');
		return 'android';
	}

	if (/iPad|iPhone|iPod/.test(userAgent)) {
		console.log('Dispositivo: iOS (Navegador)');
		return 'ios';
	}

	console.log('Dispositivo: Não é Android nem iOS');
	return null;
};

export const verifyDateTournament = (date: string) => {
	const entryEventAt = new Date(date);
	const now = new Date();

	const diffDays = differenceInDays(entryEventAt, now);
	const daysWeek = [
		'DOMINGO',
		'SEGUNDA',
		'TERÇA',
		'QUARTA',
		'QUINTA',
		'SEXTA',
		'SÁBADO',
	];

	if (isToday(entryEventAt)) {
		return `HOJE ${format(entryEventAt, 'HH:mm')}`;
	}
	if (isTomorrow(entryEventAt)) {
		return `AMANHÃ ${format(entryEventAt, 'HH:mm')}`;
	}
	if (diffDays >= 7) {
		return `${format(entryEventAt, 'dd/MM HH:mm')}`;
	} else {
		const dayWeek = daysWeek[entryEventAt.getDay()];
		return `${dayWeek} ${format(entryEventAt, 'HH:mm')}`;
	}
};

export const verifyDatePick = (date: string) => {
	const entryEventAt = new Date(date);
	const now = new Date();

	const diffDays = differenceInDays(entryEventAt, now);
	const daysWeek = [
		'Domingo',
		'Segunda',
		'Terça',
		'Quarta',
		'Quinta',
		'Sexta',
		'Sábado',
	];

	if (isToday(entryEventAt)) {
		return `Hoje ${format(entryEventAt, 'HH:mm')}`;
	}
	if (isTomorrow(entryEventAt)) {
		return `Amanhã ${format(entryEventAt, 'HH:mm')}`;
	}
	if (diffDays >= 7) {
		return `${format(entryEventAt, 'dd/MM HH:mm')}`;
	} else {
		const dayWeek = daysWeek[entryEventAt.getDay()];
		return `${dayWeek} ${format(entryEventAt, 'HH:mm')}`;
	}
};

export const getLastOrFirstName = (fullName: any) => {
	const nameParts = fullName.trim().split(/\s+/);
	return nameParts.length > 1
		? nameParts[nameParts.length - 1]
		: nameParts[0];
};

export const cdn = (url: string) => {
	return `${process.env.REACT_APP_CDN_URL}/${url}`;
};

export const pixTypeDisplay = (type: number) => {
	switch (type) {
		case 0:
			return 'CPF';
		case 1:
			return 'E-mail';
		case 2:
			return 'Telefone';
		case 3:
			return 'Chave Aleatória';
		default:
			return 'CPF';
	}
};

type FieldSide = 'up' | 'down' | 'full';

export const shouldRenderFullField = (
	draftPositions: DraftPosition[]
): FieldSide => {
	const positions = draftPositions.map((pos) => pos.position.toLowerCase());

	const upPositions = ['atacante', 'meio campo'];
	const downPositions = ['zagueiro', 'lateral', 'goleiro'];

	const hasUp = positions.some((pos) => upPositions.includes(pos));
	const hasDown = positions.some((pos) => downPositions.includes(pos));
	if (hasUp && !hasDown) {
		return 'up';
	} else if (hasDown && !hasUp) {
		return 'down';
	} else {
		return 'full';
	}
};

export const getPosition = (position: string, renderSoccerField: string) => {
	switch (position) {
		case 'Goleiro':
			return renderSoccerField === 'full'
				? [{ top: '90%', left: '50%' }]
				: [{ top: '75%', left: '50%' }];
		case 'Zagueiro':
			return renderSoccerField === 'full'
				? [
						{ top: '80%', left: '30%' },
						{ top: '80%', left: '70%' },
				  ]
				: [
						{ top: '50%', left: '30%' },
						{ top: '50%', left: '70%' },
				  ];
		case 'Lateral':
			return renderSoccerField === 'full'
				? [
						{ top: '70%', left: '10%' },
						{ top: '70%', left: '90%' },
				  ]
				: [
						{ top: '35%', left: '10%' },
						{ top: '35%', left: '90%' },
				  ];
		case 'Meio Campo':
			return renderSoccerField === 'full'
				? [
						{ top: '50%', left: '15%' },
						{ top: '40%', left: '40%' },
						{ top: '40%', left: '60%' },
						{ top: '50%', left: '85%' },
				  ]
				: [
						{ top: '75%', left: '15%' },
						{ top: '75%', left: '40%' },
						{ top: '75%', left: '60%' },
						{ top: '75%', left: '85%' },
				  ];
		case 'Linha ofensiva':
			return [
				{ top: '35%', left: '30%' },
				{ top: '35%', left: '70%' },
				{ top: '35%', left: '70%' },
				{ top: '35%', left: '70%' },
				{ top: '35%', left: '70%' },
			];
	}
};

export const getCoordinatesForPosition = (
	position: any,
	index: number,
	quantity: any,
	renderSoccerField: FieldSide
) => {
	const predefined = getPosition(position, renderSoccerField);

	if (predefined && predefined.length === quantity) {
		return predefined[index];
	} else {
		let top;
		switch (position) {
			// Futebol
			case 'Goleiro':
				top = renderSoccerField === 'full' ? '90%' : '75%';
				break;
			case 'Zagueiro':
				top = renderSoccerField === 'full' ? '77%' : '50%';
				break;
			case 'Lateral':
				top = renderSoccerField === 'full' ? '70%' : '35%';
				break;
			case 'Meio Campo':
				top = renderSoccerField === 'full' ? '45%' : '75%';
				break;
			case 'Atacante':
				top = renderSoccerField === 'full' ? '15%' : '35%';
				break;
			// Basquete
			case 'Armador':
				top = '85%';
				break;
			case 'Pivô':
				top = '15%';
				break;
			case 'Ala-Pivô':
				top = '15%';
				break;
			case 'Ala':
				top = '60%';
				break;
			case 'Ala-Armador':
				top = '60%';
				break;
			// Futebol Americano
			// Offensive
			case 'Linha ofensiva':
				top = '30%';
				break;
			case 'Corredores':
				top = '50%';
				break;
			case 'Receptores':
				top = '65%';
				break;
			case 'Quarterbacks':
				top = '85%';
				break;
			// Defensive
			case 'Linha defensiva':
				top = '30%';
				break;
			case 'Defensive backs':
				top = '50%';
				break;
			case 'Linebackers':
				top = '65%';
				break;
			case 'Equipes especiais':
				top = '85%';
				break;
			default:
				top = '50%';
		}
		const leftPercent = ((index + 1) * 100) / (quantity + 1);
		return { top, left: `${leftPercent}%` };
	}
};

export const renderPosition = (position: string) => {
	switch (position) {
		case 'Armador':
			return 'ARM';
		case 'Ala-Pivô':
			return 'ALA-P';
		case 'Ala-Armador':
			return 'ALA-A';
		case 'ALA':
			return 'ALA-A';
		case 'Pivô':
			return 'PIV';
		case 'Linha ofensiva':
			return 'LIN-O';
		case 'Corredores':
			return 'COR';
		case 'Receptores':
			return 'REC';
		case 'Quarterbacks':
			return 'QUA';
		case 'Linha defensiva':
			return 'LIN-D';
		case 'Defensive backs':
			return 'DEF';
		case 'Linebackers':
			return 'LINEB';
		case 'Equipes especiais':
			return 'EQUI-ESP';
		default:
			return position.slice(0, 3).toUpperCase();
	}
};

export const choosePlatform = () => {
	const isPickPro = process.env.REACT_APP_PICKPRO;

	if (isPickPro === 'YES') {
		return true;
	} else {
		return false;
	}
};

export const choosePlatformName = () => {
	const isPickPro = process.env.REACT_APP_PICKPRO;

	if (isPickPro === 'YES') {
		return 'PickPro';
	} else {
		return 'FUTPro';
	}
};

export const choosePlatformDomainName = () => {
	const isPickPro = process.env.REACT_APP_PICKPRO;

	if (isPickPro === 'YES') {
		return 'pickpro.com.br';
	} else {
		return 'futpro.com.br';
	}
};

export const verifyPermission = (roles: number[]) => {
	const userRoles = Array.isArray(roles) ? roles : [roles];

	if (
		[Role.ADMIN, Role.ENGINEERING, Role.SUPPORT].some((role) =>
			userRoles.includes(role)
		)
	) {
		return 'admin';
	}
	if ([Role.AFFILIATE].some((role) => userRoles.includes(role))) {
		return 'affiliate';
	}

	return 'player';
};

export const order = [
	'Gol',
	'Assistencia',
	'Assistência',
	'Passe',
	'Desarme',
	'Defesa',
	'Cartão Amarelo',
	'Cartão Vermelho',
];
